import React from "react";
import "./Navbar.css";
import logo from "../assets/landing_logo.png";

function Navbar() {
  return (
    <nav
      class="navbar navbar-default"
      style={{
        background: "#F9F0FF",
        boxShadow: "0px 2px 8px #F0F1F2",
        paddingTop: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <div class="container">
        <div class="navbar-header">
          <a class="navbar-brand" href="/">
            <img alt="logo" src={logo}></img>
          </a>
        </div>
        <ul class="nav navbar-nav navbar-right">
          <li>
            <a href="/dashboard" className="active top-buttons">
              <span class="glyphicon glyphicon-user "></span> Home
            </a>
          </li>
          <li>
            <a href="/my-patients">
              <span class="glyphicon glyphicon-log-in"></span> My Patients
            </a>
          </li>
          <li>
            <a href="/dashboard">
              <span class="glyphicon glyphicon-user"></span> My Profile
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
